import React from "react";
import { bool, func, string } from "prop-types";

const Input = ({
  placeHolder = "",
  value = "",
  className = "",
  type,
  readOnly = false,
  onChange = () => {},
  onClick = () => {},
  ...ops
}) => (
  <input
    type={type}
    onClick={onClick}
    value={value}
    readOnly={readOnly}
    placeholder={placeHolder}
    className={className}
    onChange={onChange}
    {...ops}
  />
);

Input.propTypes = {
  type: string.isRequired,
  value: string,
  placeHolder: string,
  className: string,
  readOnly: bool,
  onChange: func,
  onClick: func,
};

export default Input;
